import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { ConfirmDialogComponent } from "src/app/services/dialog/confirm-dialog/confirm-dialog.component";
import { PATTERN_ALPHA_NUMERIC_WITH_SPACE, PATTERN_NUMERIC } from "src/app/utils/constant";
import { DeviceMaintenanceService } from "../device-maintenance.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { DialogService, HelperService, LanguageService } from "src/app/services";
import { environment } from "src/environments/environment";
import { MediaObserver } from "@angular/flex-layout";
import { finalize } from "rxjs/operators";
import * as _ from "lodash";

@Component({
  selector: 'esc-device-maintenance-form',
  templateUrl: './device-maintenance-form.component.html',
  styleUrls: ['./device-maintenance-form.component.scss']
})
export class DeviceMaintenanceFormComponent implements OnInit {
  @Input() detail;
  @Input() mode;
  @Input() locations;
  @Output() saving = new EventEmitter();
  @Output() closeForm = new EventEmitter();

  public isDisabled;
  loading = {
    submit: false
  };
  branchRequired

  constructor(
    private fb: FormBuilder,
    public helper: HelperService,
    public media: MediaObserver,
    private dialogService: DialogService,
    public languageService: LanguageService,
    public deviceMntSvc: DeviceMaintenanceService
  ) {}

  public formGroup: FormGroup;

  ngOnInit() {
    this.initForm();
  }

  initForm() {
    this.formGroup = this.fb.group({
      code: [_.get(this.detail, "code"), [Validators.maxLength(8), Validators.pattern(PATTERN_ALPHA_NUMERIC_WITH_SPACE)]],

      description: [_.get(this.detail, "description"), [Validators.required, Validators.maxLength(20), Validators.pattern(PATTERN_ALPHA_NUMERIC_WITH_SPACE)]],

      imei: [_.get(this.detail, "imei"), [Validators.required, Validators.maxLength(15), Validators.pattern(PATTERN_NUMERIC)]],

      device_type: [_.get(this.detail, "device_type"), [Validators.required, Validators.maxLength(15)]],

      device_location: [_.get(this.detail, "device_location"), [Validators.required]],

      terminal_id: [_.get(this.detail, "terminal_id"), [Validators.required, Validators.maxLength(10), Validators.pattern(PATTERN_ALPHA_NUMERIC_WITH_SPACE)]],

      branch: [_.get(this.detail, "branch"), [Validators.required]],

      terminal_is_registered: _.get(this.detail, "terminal_is_registered") == 1 ? true : false,

      status: _.get(this.detail, "is_active") == 1 ? true : false
    });

    this.toggleDisable();
  }

  compareWithFunc = (a: any, b: any) => (a && b) ? a.code == b.code : null;

  toggleDisable() {
    if (!_.get(this.detail, 'id')) {
      this.formGroup.get("status").disable({ emitEvent: false });
      this.formGroup.get("status").setValue(true);
      this.formGroup.get("terminal_is_registered").setValue(false);
    } else {
      this.formGroup.get("code").disable({ emitEvent: false });
    }
  }

  branchSelected(ev) {
    this.formGroup.get('branch').setValue(ev);
    this.formGroup.get('branch').markAsTouched();
  }

  isFormValid() {
    if(this.formGroup.valid) {
      this.saveChanges()
    }
    else {
      for (let ctrl in this.formGroup.controls) {
        if(!this.formGroup.controls[ctrl].valid) {
          this[ctrl+"Required"] = true;
        }
      }
    }
  }

  saveChanges() {
    this.loading.submit = true;
    this.formGroup.disable();
    this.isDisabled = true;

    let terminal_is_registered = _.get(this.formGroup.get("terminal_is_registered"), "value") ? 1 : 0;
    let is_active = _.get(this.formGroup.get("status"), "value") ? 1 : 0;

    let obj = {
      data: [
        {
          id: _.get(this.detail, "id") || 0,

          code: _.get(this.formGroup.get("terminal_id"), "value"),

          description: _.toUpper(_.get(this.formGroup.get("description"), "value")),

          imei: _.get(this.formGroup.get("imei"), "value"),

          device_type: _.get(this.formGroup.get("device_type"), "value"),

          device_location_id: _.get(this.formGroup.get("device_location"), "value.id"),

          terminal_id: _.get(this.formGroup.get("terminal_id"), "value"),

          branch_id: _.get(this.formGroup.get("branch"), "value.id"),

          terminal_is_registered: terminal_is_registered,

          is_active: is_active
        }
      ]
    };

    this.saving.emit(true);

    this.deviceMntSvc.insert(obj).pipe(
      finalize(() => {
        this.loading.submit = false;
        this.saving.emit(false);
        this.formGroup.enable();
        this.toggleDisable();
        this.isDisabled = false;
      }))
      .subscribe(
        (res: any) => {
          if (environment.showLogs) {
            console.log(res);
          }

          if (_.has(res, 'status') && _.get(res, 'status') == 0) {
            this.helper.networkErrorMessage();
            return;
          }

          if(this.helper.displayErrorMessage(res)) return;
          
          if (_.get(res, 'success.count') > 0) {
            //the ff needs to be an obj to display detail correctly
            obj.data[0]["branch"] = _.get(this.formGroup.get("branch"), "value");
            obj.data[0]["device_location"] = _.get(this.formGroup.get("device_location"), "value");

            this.saving.emit(obj.data);
            this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_DATA_UPDATED", {}));
            this.close(true);
          }
        },
        err => {
          console.log(err);
        }
      );
  }

  disableSaveBtn() {
    return this.loading.submit || (this.formGroup.touched && !this.formGroup.valid)
  }

  confirmChanges() {
    if(this.formGroup.touched && this.formGroup.valid) {
      this.dialogService.openDialog(ConfirmDialogComponent, {
        width: "400px",
        autoFocus: true,
        disableClose: true,
        data: {
          title: this.languageService.getTranslation("MSG_CONFIRM_ACTION", {}),
          message: this.languageService.getTranslation("MSG_SAVE_CHANGES", {}),
          button: this.languageService.getTranslation("LABEL_YES", {}),
          cancelButton: this.languageService.getTranslation("LABEL_NO", {}),
        }
      })
      .afterClosed()
      .subscribe(result => {
        if(result) {
          this.saveChanges();
        } else {
          this.close(false);
        }
      })
    }
    else {
      this.close(false);
    }
  }

  close(data) {
    this.closeForm.next(data);
  }
}